import React, { useState } from 'react'
import { InputRow, LabelDots, Loader, Popup, SortableTable, genericTexts, SplitButton } from 'hub-web-lib'
import { METRICS_TYPE, FINDINGS_TYPE, valuesPropsGeneric, WIDGET, KEY } from 'js/constants/metrics/common-metrics'
import { LIKELIHOOD, riskAssessmentMetricsCategories, riskAssessmentMetricsKeys, riskAssessmentMetricsWidgets } from 'js/constants/metrics/risk-assessment-metrics'
import store from 'js/store'
import { action } from 'js/actions'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import { connect } from 'react-redux'
import UserApi from 'services/UserApi'
import 'scss/UpdateActivity/MetricsTable.scss'
import { checkImportingErrors, getActivityInfoMetricsColumnsForm, getActivityMetricsValuesProps, getChangedMetrics, getMetricId, getMetricsConsts, getMetricsLabelDots, getRequiredFieldError, getTextFields, getValuesFieldsDynamic, preparePredefinedMetrics, refactorImportedMetrics } from 'js/ui-helpers/metrics'
import RiskAssessmentApi from 'services/RiskAssessmentApi'
import { DOWNLOAD_CLOUD, DOWNLOAD_FINDINGS_TEMPLATE, DOWNLOAD_METRICS_TEMPLATE, IMPORT_FINDINGS, IMPORT_METRICS, UPLOAD_CLOUD, metricsButtonsList } from 'js/constants/enums/common-activity'
import ImportTemplateButtons from 'components/Modules/Activity/ImportPlaceholder/ImportTemplateButtons'
import { RISK_ASSESSMENT_MODULE } from 'js/constants/app-modules'
import { LIKELIHOOD_DIMENSION, RISK_DIMENSION } from 'js/constants/dashboard-settings'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser,
        dashboardSettings: state.dashboardSettings
    }
}
const RiskAssessmentActivityMetricsComponent = ({ data, currentUser, dashboardSettings }) => {
    const currentOrgId = currentUser?.current_org
    const {
        newMetricModel,
        customMetrics,
        predefinedMetricsToEdit,
        updateMetrics,
        templateUrl,
        findingsUrl,
        activityToUpdate,
        hasFindings,
        setActivityFindings
    } = data


    const templateType = activityToUpdate?.template_type || 1
    const riskAssessmentValuesProps = getActivityMetricsValuesProps(dashboardSettings, RISK_ASSESSMENT_MODULE, RISK_DIMENSION)
    const riskAssessmentLikelihoodProps = getActivityMetricsValuesProps(dashboardSettings, RISK_ASSESSMENT_MODULE, LIKELIHOOD_DIMENSION)
    const metricsConsts = getMetricsConsts(
        riskAssessmentMetricsCategories, 
        riskAssessmentMetricsWidgets, 
        riskAssessmentMetricsKeys, 
        riskAssessmentValuesProps
    )

    const labelDotsItems = getMetricsLabelDots(metricsConsts)

    const [custom, setCustom] = useState(customMetrics)
    const [predefined, setPredefined] = useState(preparePredefinedMetrics(predefinedMetricsToEdit, metricsConsts))
    const [metricsFile, setMetricsFile] = useState(null)
    const [sheetName, setSheetName] = useState('')
    const [fileType, setFileType] = useState('')
    const [isOpenedMetricsPopUp, setIsOpenedMetricsPopUp] = useState(false)
    const [isOpenedSheetPopUp, setIsOpenedSheetPopUp] = useState(false)
    const [isImportingMetrics, setIsImportingMetrics] = useState(false)
    const [importingErrors, setImportingErrors] = useState([])
    const [isOpenedMetricsErrorsPopup, setIsOpenedMetricsErrorsPopup] = useState(false)
    const isRiskAssessmentWarningMessageDisabled = UserApi.getUserProp('isRiskAssessmentWarningMessageDisabled', currentUser?.id)
    const [isWarningDisabled, setIsWarningDisabled] = useState(JSON.parse(isRiskAssessmentWarningMessageDisabled))
    const [isButtonLoading, setIsButtonLoading] = useState(false)
    const currentDate = new Date()
    currentDate.setDate(currentDate.getDate() - 1)

    // labelDotsItems = getMetricsLabelDotsByTemplateType(labelDotsItems, activityToUpdate?.template_type)

    const changeFile = (file) => {
        setMetricsFile(file)
        setIsOpenedSheetPopUp(true)
        setIsOpenedMetricsPopUp(false)
        setIsOpenedMetricsErrorsPopup(false)
    }

    const importMetricsClick = () => {
        UserApi.setUserPropCookie('isRiskAssessmentWarningMessageDisabled', isWarningDisabled, currentUser?.id, true)
        const importMetricsRow = document.getElementById('fileUpload')
        importMetricsRow.click()
    }

    const checkIfCookiesExists = (type) => {
        setFileType(type)
        isWarningDisabled ? importMetricsClick(type) : setIsOpenedMetricsPopUp(true)
    }

    const closeSheetPopUp = () => {
        setIsOpenedSheetPopUp(false)
        setSheetName('')
        setFileType('')
    }

    const uploadNewFile = async (type = fileType) => {
        if (!metricsFile) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: 'Please choose a file', notificationType: 'error' }))
            return
        }
        const isMetricsFile = type === METRICS_TYPE
        setIsImportingMetrics(true)
        setIsButtonLoading(true)
        const formData = new FormData()
        formData.append('file', metricsFile)
        const importedMetricsData = isMetricsFile ? await RiskAssessmentApi.postMetricsFile(currentOrgId, formData, sheetName) : await RiskAssessmentApi.postFindingsFile(currentOrgId, formData)
        if (!importedMetricsData || importedMetricsData.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: `Import failed: ${importedMetricsData.error}`, notificationType: 'error' }))
            setIsButtonLoading(false)
            setIsOpenedSheetPopUp(false)
            setIsImportingMetrics(false)
            return
        }
        const updatedMetrics = refactorImportedMetrics(isMetricsFile ? (importedMetricsData.risk_assessment_metrics?.data_entities || []) : (importedMetricsData?.metrics || []), valuesPropsGeneric)
        setPredefined(updatedMetrics)
        updateMetrics(updatedMetrics, true)
        setActivityFindings(importedMetricsData?.findings || [])
        checkImportingErrors(importedMetricsData?.redteam_metrics, updatedMetrics, setImportingErrors, setIsOpenedMetricsErrorsPopup)
        setIsOpenedSheetPopUp(false)
        setIsButtonLoading(false)
        setIsImportingMetrics(false)
        setFileType('')
    }

    const downloadTemplate = (type) => {
        const url = type === METRICS_TYPE ? templateUrl[templateType] : findingsUrl[templateType]
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer')
        } else {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: 'Template not found', notificationType: 'error' }))
        }
    }

    const handleSplitButtonClick = (val) => {
        switch (val) {
        case 1: {
            downloadTemplate(METRICS_TYPE)
            break
        }
        case 2: {
            downloadTemplate(FINDINGS_TYPE)
            break
        }
        case 3: {
            checkIfCookiesExists(METRICS_TYPE)
            break
        }
        case 4: {
            checkIfCookiesExists(FINDINGS_TYPE)
            break
        }
        }
    }

    const changeMetricValue = (key, i, val, isPredefined) => {
        let updatedMetrics = getMetrics(isPredefined)
        updatedMetrics = getChangedMetrics(updatedMetrics, key, i, val, metricsConsts)
        setMetrics(updatedMetrics, isPredefined)
        updateMetrics(updatedMetrics, isPredefined)
    }

    const addNewMetric = () => {
        const updatedMetrics = [...custom, { ...newMetricModel }]
        setCustom(updatedMetrics)
    }

    const deleteMetric = (index, isPredefined) => {
        const updatedMetrics = (getMetrics(isPredefined)).filter((_, i) => i !== index)
        setMetrics(updatedMetrics, isPredefined)
        updateMetrics(updatedMetrics, isPredefined)
    }
    const setMetrics = (updatedMetrics, isPredefined) => {
        isPredefined ? setPredefined(updatedMetrics) : setCustom(updatedMetrics)
    }

    const getMetrics = (isPredefined) => {
        return isPredefined ? [...predefined] : [...custom]
    }

    const checkRequiredField = (val, isPredefined, i) => {
        const metrics = getMetrics(isPredefined)
        return getRequiredFieldError(val, i, isPredefined, metrics.length) 
    }

    const metricsFunctions = {
        changeMetricValue,
        checkRequiredField,
        deleteMetric
    }

    const getMetricsTableData = (isPredefined) => {
        const metrics = getMetrics(isPredefined)
        const data = metrics.map((metric, i) => {
            const id = getMetricId(metric, i, isPredefined, predefined)
            let keyToDisplay
            if (metric[WIDGET] === LIKELIHOOD) keyToDisplay = riskAssessmentLikelihoodProps.find(p => p.id === metric[KEY])?.name
            const metricProps = {
                metric, 
                i,
                metricsLength: metrics.length,
                id, 
                isPredefined,
                keyToDisplay
            }
            const valuesFields = getValuesFieldsDynamic(metricProps, metricsConsts, metricsFunctions, hasFindings)
            const textFields = getTextFields(metricProps, metricsConsts, metricsFunctions, false, hasFindings)
            return {
                id,
                ...metric,
                ...textFields,
                ...valuesFields,
            }
        })
        return data
    }

    const customMetricsTableData = getMetricsTableData(false)
    const predefinedMetricsTableData = getMetricsTableData(true)
    const metricsTableColumns = getActivityInfoMetricsColumnsForm(riskAssessmentValuesProps)
    metricsTableColumns[3].name = <span className='absolute-th'>Values</span>

    const templateButtons = [ { func: () => downloadTemplate(METRICS_TYPE), title: DOWNLOAD_METRICS_TEMPLATE, icon: DOWNLOAD_CLOUD, id: 'download-redteam-metrics' },
        { func: () => downloadTemplate(FINDINGS_TYPE), title: DOWNLOAD_FINDINGS_TEMPLATE, icon: DOWNLOAD_CLOUD, id: 'download-redteam-findings' },
        { func: () => checkIfCookiesExists(METRICS_TYPE), title: IMPORT_METRICS, icon: UPLOAD_CLOUD, id: 'import-redteam-metrics' },
        { func: () => checkIfCookiesExists(FINDINGS_TYPE), title: IMPORT_FINDINGS, icon: UPLOAD_CLOUD, id: 'import-redteam-findings' }]

    return (
        <div className='metrics-tables metrics-tables-easm'>
            <div className='metrics-tables-header'>
                <div>
                    <h3 id='easm-activity-metrics'>Activity Metrics</h3>
                </div>
                {!!predefined.length && <div className='metrics-tables-header-buttons'>
                    <SplitButton buttonsList={metricsButtonsList} selectedButtonId={1} splitButtonId='lets-split' splitButtonClass='btn-set' handleButtonClick={handleSplitButtonClick} />
                </div>}
            </div>
            {predefined.length ?  
                <>
                    <fieldset>
                        <LabelDots list={labelDotsItems} />
                    </fieldset>
                    {!hasFindings && <fieldset className='editable-table metrics-tables-custom'>

                        <SortableTable
                            columns={metricsTableColumns}
                            tableData={customMetricsTableData}
                            itemsPerPage={0}
                            noFilter={true}
                            tableId='risk-assessment-activity-metrics-custom-table' />
                        <div className='editable-table-bottom'>
                            <button className='btn-link' onClick={addNewMetric} id='add-custom-metric'><i className='icon-plus'></i> Custom Metrics</button>
                        </div>
                    </fieldset>}
                    <fieldset className='editable-table metrics-tables-predefined'>
                        {isImportingMetrics ? <Loader /> : <SortableTable
                            columns={metricsTableColumns}
                            tableData={predefinedMetricsTableData}
                            itemsPerPage={0}
                            tableId='risk-assessment-activity-metrics-predefined-table' />}
                    </fieldset>
                </> : 
                <ImportTemplateButtons templateButtons={templateButtons} />
            }
            <Popup
                isOpen={isOpenedMetricsPopUp}
                onClose={() => setIsOpenedMetricsPopUp(false)} title={<div><i className='icon-warning'></i> {genericTexts.defaultText.deletePopupTitle}</div>}
                isDisabledClickOutside={true}>
                <p> By importing the file, existing data will be overwritten. This action cannot be undone.</p>
                <div className='hidden-row'><InputRow
                    inputId='fileUpload'
                    title='Import Metrics'
                    inputType='file'
                    changeValueHandler={changeFile}
                    defaultValue={metricsFile} /></div>
                <InputRow inputId='checkbox' title='Don’t show again' inputType='checkbox' defaultValue={isWarningDisabled} changeValueHandler={setIsWarningDisabled} />

                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={importMetricsClick} id='got-it'>Got It</button>
                </div>
            </Popup>
            <Popup
                isOpen={isOpenedMetricsErrorsPopup}
                onClose={() => setIsOpenedMetricsErrorsPopup(false)} title={<div><i className='icon-warning'></i> Import Warnings</div>}
                customClass='import-errors'>
                <p>Import completed with warnings. You can fix your file and upload again or fill the missed fields</p>
                {importingErrors.map((error, i) => <p key={i} className='error-msg' id={`easm-import-error-${i}`}>{error}</p>)}
                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={() => setIsOpenedMetricsErrorsPopup(false)} id='import-warning-ok'>OK</button>
                </div>
            </Popup>
            <Popup
                isOpen={isOpenedSheetPopUp}
                onClose={closeSheetPopUp} title={<div className='popup-cloud-icon'><i className='icon-upload-cloud'></i></div>}>
                <div className='sheet-name-popup'>
                    <div className='sheet-file-name'><span>{metricsFile?.name || ''}</span></div>
                    {fileType === METRICS_TYPE && <InputRow
                        inputId='textInput'
                        placeholder='Enter Sheet name'
                        title='Sheet Name'
                        defaultValue={sheetName}
                        changeValueHandler={setSheetName} />}
                </div>
                <div className='popup-buttons'>
                    <button className={`btn-submit ${isButtonLoading ? 'loader' : ''}`} onClick={() => uploadNewFile(fileType)} id='upload-metrics'>Upload</button>
                </div>
            </Popup>
        </div>)
}


const RiskAssessmentActivityMetrics = connect(mapStateToProps)(RiskAssessmentActivityMetricsComponent)

export default RiskAssessmentActivityMetrics

